<template>
    <div>

        <div style="padding:5px 5px 5px 5px">
            <div class="assembly-header">
                <p style="display:inline;float: left;line-height: 22px;">
                    <b>装配列表</b>
                </p>
            </div>
        </div>

        <el-table :data="orderList" style="width: 100%" highlight-current-row>
            <el-table-column prop="orderCode" label="订单编号" min-width="13%">
            </el-table-column>
            <el-table-column prop="orderCount" label="订单数量" min-width="8%" align="center">
            </el-table-column>

            <el-table-column prop="productName" label="产品名称" min-width="15%">
            </el-table-column>
            <el-table-column prop="moldCode" label="模具编号" min-width="12%">
            </el-table-column>

            <el-table-column prop="createdTime" label="下单日期" min-width="10%">
            </el-table-column>
            <el-table-column prop="deliveryTime" label="交货日期" min-width="10%">
            </el-table-column>

            <el-table-column prop="status" label="加工状态" min-width="8%">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="16%">
            </el-table-column>

            <el-table-column prop="assemblyDes" label="装配状态" min-width="8%" fixed="right">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                        更改
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="5" :page-count="pageCount" layout="prev, pager, next" :total="total"
                @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div>

        <el-dialog title="装配详情" :visible.sync="dialogFormVisible" width="60%">

            <el-form :inline="true" :model="orderForm">
                <el-form-item label="订单编号" required :label-width="formLabelWidth">
                    <el-input v-model="orderForm.orderCode" autocomplete="off" style="width:220px" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item label="订单数量" required :label-width="formLabelWidth">
                    <el-input-number v-model="orderForm.orderCount" :step="1" :min="1" style="width:220px"
                        disabled></el-input-number>
                </el-form-item>

                <el-form-item label="客户" required :label-width="formLabelWidth">
                    <el-input v-model="orderForm.customer" autocomplete="off" style="width:220px" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item label="业务员" required :label-width="formLabelWidth">
                    <el-select v-model="orderForm.salesman" placeholder="请选择" style="width:220px" disabled>
                        <el-option v-for="item in orderForm.empList" :key="item.value" :label="item.employeeName"
                            :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="产品名称" required :label-width="formLabelWidth">
                    <el-input v-model="orderForm.productName" autocomplete="off" style="width:220px" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item label="模具编号" required :label-width="formLabelWidth">
                    <el-input v-model="orderForm.moldCode" autocomplete="off" style="width:220px"
                        :disabled="moldCodeDisable"></el-input>
                </el-form-item>

                <el-form-item label="下单日期" required :label-width="formLabelWidth">
                    <el-date-picker v-model="orderForm.createdTime" type="date" placeholder="选择日期" disabled>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="交货日期" required :label-width="formLabelWidth">
                    <el-date-picker v-model="orderForm.deliveryTime" type="date" placeholder="选择日期" disabled>
                    </el-date-picker>
                </el-form-item>
                <div style="width:350px;display: inline-block;"></div>

                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="orderForm.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                </el-form-item>

                <el-form-item label="装配状态" :label-width="formLabelWidth">
                    <el-radio-group v-model="assemblyProgress" style="width:570px">
                        <el-radio :label="0">待装配</el-radio>
                        <el-radio :label="1">装配中</el-radio>
                        <el-radio :label="2">已完成</el-radio>
                    </el-radio-group>

                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addMoldOrder" v-show="saveButtonVisible1">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "Assembly",
    data() {
        return {
            gc: 0,
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            activeName: 'first',
            orderList: [],
            dialogFormVisible: false,
            saveButtonVisible1: true,

            statusSearch: 3,
            assemblyProgressSearch: 0,
            orderForm: {
                id: '',
                orderCode: '自动生成',
                orderCount: 1,
                customer: '',
                empList: [],
                salesman: '',
                salesmanId: '',
                productName: '',
                moldCode: '',
                createdTime: '',
                deliveryTime: '',
                status: 0,
                remark: '',
            },
            assemblyProgress: 0,
            polishProgress: 0,
            formLabelWidth: '120px',
            moldCodeDisable: true,
            // assemblyStyle: {
            //     display: 'none'
            // },
            polishProcessList: [],
            polishDialogVisible: false,
            form: {
                id: '',
                moldCode: '',
                processName: '',
                processType: 1,
                status: 0,
                maker: '',
                remark: '',
            },
            processNameDisable: false,
            statusVisible: false,
            pageIndex:0,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        // tabClick(tab, event) {
        //     //console.log(tab, event);
        //     if (tab.index == "0") {
        //         this.assemblyProgressSearch = 0
        //         this.getAllOrder(this.statusSearch)
        //     } else {
        //         this.assemblyProgressSearch = 2
        //         this.getAllOrder(this.statusSearch)
        //     }
        // },
        handleClick(row) {
            // console.log(row);
            this.orderForm.id = row.id

            this.orderForm.orderCode = row.orderCode
            this.orderForm.orderCount = row.orderCount

            this.orderForm.customer = row.customer
            this.orderForm.salesman = row.salesmanId

            this.orderForm.productName = row.productName
            this.orderForm.moldCode = row.moldCode

            this.orderForm.createdTime = row.createdTime
            this.orderForm.deliveryTime = row.deliveryTime

            this.orderForm.status = null
            this.orderForm.remark = row.remark
            this.assemblyProgress = row.assemblyProgress

            // this.assemblyStyle.display='none'
            // if(row.status=='完成'){
            //     this.assemblyStyle.display=''
            // }


            this.dialogFormVisible = true
        },
        // selectClick(selection, row) {
        //     this.$refs.polishTable.clearSelection()
        //     this.$refs.polishTable.toggleRowSelection(row)
        //     this.form.moldCode = row.moldCode
        //     this.getAllPolishProcess()
        // },
        // rowClick(row) {
        //     //console.log(row)
        //     this.$refs.polishTable.clearSelection()
        //     this.$refs.polishTable.toggleRowSelection(row)
        //     this.form.moldCode = row.moldCode
        //     this.getAllPolishProcess()
        // },
        openDialog() {

            if (this.form.sparePartCode == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择BOM'
                })
                return
            }

            this.form.id = ''
            //this.form.moldCode = ''
            this.form.processName = ''
            //this.form.takeTime = ''
            //this.form.processType = 1
            this.form.status = 0
            this.form.maker = this.userId
            this.form.remark = ''

            this.processNameDisable = false
            this.statusVisible = false
            this.polishDialogVisible = true
        },
        editClick(row) {

            this.form.id = row.id
            this.form.processName = row.processName
            this.form.status = row.status
            this.form.remark = row.remark

            this.processNameDisable = true
            this.statusVisible = true
            this.polishDialogVisible = true
        },
        // increase() {
        //     this.assemblyProgress += 10;
        //     if (this.assemblyProgress > 100) {
        //         this.assemblyProgress = 100;
        //     }
        // },
        // decrease() {
        //     this.assemblyProgress -= 10;
        //     if (this.assemblyProgress < 0) {
        //         this.assemblyProgress = 0;
        //     }
        // },
        getAllOrder(val) {

            const formData = new FormData()
            formData.append('status', val)
            formData.append('assemblyProgress', this.assemblyProgressSearch)
            formData.append('companyId', this.companyId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', 10)

            this.$axios({
                method: "post",
                url: "/shiro/mold/order/getAll",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                this.orderList = data.data
                this.total = this.orderList[0].total
                for (let i in this.orderList) {
                    this.orderList[i].createdTime = this.$moment(this.orderList[i].createdTime).format("YYYY-MM-DD")
                    this.orderList[i].deliveryTime = this.$moment(this.orderList[i].deliveryTime).format("YYYY-MM-DD")

                    if (this.orderList[i].status == 0) {
                        this.orderList[i].status = '待产'
                    } else if (this.orderList[i].status == 1) {
                        this.orderList[i].status = '生产中'
                    } else if (this.orderList[i].status == 2) {
                        this.orderList[i].status = '暂停'
                    } else {
                        this.orderList[i].status = '完成'
                    }

                    if (this.orderList[i].assemblyProgress == 0) {
                        this.orderList[i].assemblyDes = '待装配'
                    } else if (this.orderList[i].assemblyProgress == 1) {
                        this.orderList[i].assemblyDes = '装配中'
                    } else {
                        this.orderList[i].assemblyDes = '完成'
                    }

                    if (this.orderList[i].polishProgress == 0) {
                        this.orderList[i].polishDes = '待抛光'
                    } else if (this.orderList[i].polishProgress == 1) {
                        this.orderList[i].polishDes = '抛光中'
                    } else if (this.orderList[i].polishProgress == 2) {
                        this.orderList[i].polishDes = '暂停'
                    } else {
                        this.orderList[i].polishDes = '完成'
                    }
                }
            })
        },
        addMoldOrder() {
            this.$axios({
                method: "post",
                url: "/shiro/mold/order/add",
                data: {
                    id: this.orderForm.id,
                    //orderCode: this.orderForm.orderCode,
                    //orderCount: this.orderForm.orderCount,
                    //customer: this.orderForm.customer,
                    //salesman: this.orderForm.salesman,
                    //productName: this.orderForm.productName,
                    //moldCode: this.orderForm.moldCode,
                    //createdTime: this.orderForm.createdTime,
                    //deliveryTime: this.orderForm.deliveryTime,
                    //status: this.orderForm.status,
                    remark: this.orderForm.remark,
                    assemblyProgress: this.assemblyProgress,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.dialogFormVisible = false
                this.getAllOrder(this.statusSearch)
            })
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removePolishProcess(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        removePolishProcess(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/process/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAllPolishProcess()
            })
        },
        pageClick(currentPage){
            this.pageIndex=(currentPage-1)*10
            this.getAllOrder(this.statusSearch)
        }
    },
    mounted() {
        this.getAllOrder(this.statusSearch)
    },
    updated() {
        var checkBoxEle = document.getElementsByClassName("el-checkbox")
        // console.log(checkBoxEle)
        if (checkBoxEle.length > 0) {
            checkBoxEle[0].innerHTML = ''
        }

        // console.log(this.gc)
        // if (this.gc == 2) {

        //     this.$refs.polishTable.toggleRowSelection(this.$refs.polishTable.tableData[0])
        //     this.form.moldCode = this.$refs.polishTable.tableData[0].moldCode
        //     this.getAllPolishProcess()
        // }
        // this.gc++
    }
}
</script>

<style>
.assembly-header {
    height: 50px;
    line-height: 50px;
    color: orange;
    background-color: #f2f5f6;
    /* box-shadow: 0 0 6px rgba(0, 0, 0, .12); */
    border-radius: 5px;
    border: 1px solid #6f5499;
    margin: 0 0 20px 0;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>